import styled, { css } from 'styled-components';
import { breakpoint, heading, text } from '@carvana/ds-styles';

const gradient = css`
  background: radial-gradient(
    ellipse farthest-corner at top left,
    rgb(0, 63, 158) 0%,
    rgb(0, 178, 217) 60%,
    rgb(112, 234, 242) 100%
  );
`;

const HeaderBg = styled.div`
  margin-bottom: 24px;
  padding-bottom: 122px;
  padding-top: 50px;

  &.error {
    height: 196px;
  }

  @media screen and (min-width: ${breakpoint.sm}) {
    padding-bottom: 167px;
    padding-top: 51px;

    &.error {
      height: 150px;
    }
  }

  @media screen and (min-width: ${breakpoint.md}) {
    padding-bottom: 158px;
    padding-top: 50px;

    &.error {
      height: 185px;
    }
  }
`;

const Heading = styled.h1`
  ${heading['3Xl']}
  color: ${text.inverse};
  text-transform: uppercase;

  @media screen and (min-width: ${breakpoint.sm}) {
    &.error {
      width: 500px;
    }
  }

  @media screen and (min-width: ${breakpoint.md}) {
    ${heading['4Xl']}

    &.error {
      width: 600px;
    }
  }
`;

const HeaderContent = styled.div`
  max-width: 327px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 3px;

  &.forceHeaderLineBreak {
    max-width: 303px;
    padding-right: 24px;
  }

  @media screen and (min-width: ${breakpoint.sm}) {
    &.forceHeaderLineBreak {
      max-width: 704px;
      padding-right: 0;
    }
    max-width: 704px;
    padding-right: 0;
    margin-top: -1px;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    &.forceHeaderLineBreak {
      max-width: 960px;
    }
    max-width: 960px;
    margin-top: 0;
  }
`;

const Subheading = styled.p`
  color: ${text.inverse};
  font-size: 18px;
  line-height: 26px;
  margin-top: 8px;
  max-width: 312px;

  &.forceSubheaderLineBreak {
    max-width: 212px;
  }

  @media screen and (min-width: ${breakpoint.sm}) {
    &.forceSubheaderLineBreak {
      max-width: unset;
    }
    max-width: 366px;
    font-size: 18px;
    line-height: 26px;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 24px;
    line-height: 30px;
    margin-left: -4px;
    margin-top: 24px;
    max-width: 710px;
  }

  &.lowValue {
    max-width: 305px;

    @media screen and (min-width: ${breakpoint.sm}) {
      max-width: 450px;
    }

    @media screen and (min-width: ${breakpoint.md}) {
      max-width: 555px;
    }
  }
`;

const Wrapper = styled.section`
  ${gradient}
`;

export { HeaderBg, HeaderContent, Heading, Subheading, Wrapper };
